import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type ManageNumbersStore } from 'pages/settings/pages/numbers/ui/ManageNumbers/store/ManageNumbersStore'

export const ManageNumbersActions = observer(
  ({ manageNumbersStore }: { manageNumbersStore: ManageNumbersStore }) => {
    const {
      addLicenseNumber,
      onLicenseBuy,
      onManageNumbersModalClose,
      disableButton,
      loadingButton,
    } = manageNumbersStore
    return (
      <>
        <Button
          disabled={disableButton}
          typeBtn={'contained'}
          text={'Cancel'}
          size={'medium'}
          contained={'secondary'}
          onClick={onManageNumbersModalClose}
        />
        <Button
          disabled={disableButton}
          loading={loadingButton}
          typeBtn={'contained'}
          text={`Buy ${addLicenseNumber || 1} number license${
            parseInt(addLicenseNumber) > 1 ? 's' : ''
          }`}
          size={'medium'}
          onClick={onLicenseBuy}
        />
      </>
    )
  }
)
